/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Liability_TitleInputs */

const en_agb_liability_title = /** @type {(inputs: Agb_Liability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Limitation of Liability`)
};

const de_agb_liability_title = /** @type {(inputs: Agb_Liability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Haftungsbeschraenkung`)
};

const fr_agb_liability_title = /** @type {(inputs: Agb_Liability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Limitation de responsabilité`)
};

const es_agb_liability_title = /** @type {(inputs: Agb_Liability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Limitación de responsabilidad`)
};

const it_agb_liability_title = /** @type {(inputs: Agb_Liability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Limitazione di responsabilità`)
};

const nl_agb_liability_title = /** @type {(inputs: Agb_Liability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Beperking van aansprakelijkheid`)
};

const pl_agb_liability_title = /** @type {(inputs: Agb_Liability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Ograniczenie odpowiedzialności`)
};

const fi_agb_liability_title = /** @type {(inputs: Agb_Liability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Vastuunrajoitus`)
};

const da_agb_liability_title = /** @type {(inputs: Agb_Liability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Ansvarsbegrænsning`)
};

const sv_agb_liability_title = /** @type {(inputs: Agb_Liability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Ansvarsbegränsning`)
};

/**
* | output |
* | --- |
* | "8. Limitation of Liability" |
*
* @param {Agb_Liability_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_liability_title = /** @type {((inputs?: Agb_Liability_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Liability_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_liability_title(inputs)
	if (locale === "fr") return fr_agb_liability_title(inputs)
	if (locale === "es") return es_agb_liability_title(inputs)
	if (locale === "it") return it_agb_liability_title(inputs)
	if (locale === "nl") return nl_agb_liability_title(inputs)
	if (locale === "pl") return pl_agb_liability_title(inputs)
	if (locale === "fi") return fi_agb_liability_title(inputs)
	if (locale === "da") return da_agb_liability_title(inputs)
	if (locale === "sv") return sv_agb_liability_title(inputs)
	return en_agb_liability_title(inputs)
});